import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {FieldComponent} from "../fields/field/field.component";
import {FieldDefinition} from "../../../model/field-definition";

@Component({
    selector: 'app-dynamic-form',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FieldComponent,
        FieldComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './dynamic-form.component.html',
    styleUrl: './dynamic-form.component.scss'
})
export class DynamicFormComponent implements OnInit {
  @Input() questions: FieldDefinition<any>[] = [];
  @Input() form: FormGroup;
  @Output() formChange = new EventEmitter<FormGroup>();

  constructor() {
  }

  ngOnInit() {
    this.formChange.emit(this.form);
  }
}
